import { z } from 'zod'

// Base state validation schema
export const baseStateSchema = z.object({
  loading: z.boolean(),
  error: z.string().nullable()
})

// Paginated state validation schema - using object destructuring for Zod 4 compatibility
export const paginatedStateSchema = z.object({
  ...baseStateSchema.shape,
  page: z.number().int().min(1),
  limit: z.number().int().min(1),
  total: z.number().int().min(0)
})

// Filterable state validation schema - using object destructuring for Zod 4 compatibility
export const filterableStateSchema = z.object({
  ...baseStateSchema.shape,
  filterParams: z.record(z.string(), z.unknown()).nullable()
})

// Type inference helpers
export type BaseStateSchema = z.infer<typeof baseStateSchema>
export type PaginatedStateSchema = z.infer<typeof paginatedStateSchema>
export type FilterableStateSchema = z.infer<typeof filterableStateSchema>
